// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Gb6C","clinicsSelect":"TableHeading_clinicsSelect__28S9K"};